import { render, staticRenderFns } from "./JohanSocial.vue?vue&type=template&id=207bd629"
import script from "./JohanSocial.vue?vue&type=script&lang=js"
export * from "./JohanSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports